import axios from "@/api/axiosInstance";
import { CreateProcessWheelRequest, CreateProcessWheelResponse } from "./types";

export const createProcessWheel = async (
  requestData: CreateProcessWheelRequest,
): Promise<CreateProcessWheelResponse> => {
  const response = await axios.post<CreateProcessWheelResponse>(
    "/api/private/admin/process-wheels",
    requestData,
  );
  return response.data;
};
